import React from 'react';
import PropTypes from 'prop-types';
import { Eye, EyeOff } from 'react-feather';

const PwdEyeButton = ({ type, settype }) => (
  <button
    type="button"
    onClick={() => settype(type === 'password' ? 'text' : 'password')}
  >
    {type === 'text' ? (
      <Eye size={20} color="#555" />
    ) : (
      <EyeOff size={20} color="#555" />
    )}
  </button>
);

PwdEyeButton.propTypes = {
  type: PropTypes.string,
  settype: PropTypes.func,
};

PwdEyeButton.defaultProps = {
  type: 'password',
  settype: () => {},
};

export default PwdEyeButton;
